import { ShoppingCartIcon as SolidShoppingCartIcon } from "@heroicons/react/24/solid";
import { ShoppingCartIcon as OutlineShoppingCartIcon } from "@heroicons/react/24/outline";

interface Props {
  isInCart: boolean;
  onClick: () => void;
  className?: string;
}

export default function CartButton(props: Props) {
  const { isInCart, onClick, className = "" } = props;
  return (
    <button
      type="button"
      onClick={() => onClick()}
      className={`transition-transform ${isInCart ? "heart-beat" : ""} ${className}`.trim()}
    >
      {isInCart ? (
        <SolidShoppingCartIcon className={"h-6 w-6 text-red-500"} />
      ) : (
        <OutlineShoppingCartIcon className={"h-6 w-6 text-gray-600"} />
      )}
    </button>
  );
}
